import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeLabels = {
    '/admin-dashboard': 'Dashboard',
    '/executive-dashboard': 'Dashboard Ejecutivo',
    '/piece-registration': 'Registro de Piezas',
    '/piece-registration-form': 'Registro de Piezas',
    '/employee-management': 'Empleados',
    '/client-management': 'Clientes',
    '/product-management-simple': 'Productos',
    '/loncheados-control-center': 'Control de Loncheados',
    '/client-profitability-analysis': 'Rentabilidad por Cliente',
    '/financial-analysis-dashboard': 'Análisis Financiero',
    '/salarios': 'Salarios',
    '/ldd-rentabilidad-control': 'LDD Rentabilidad-Control',
    '/particulares-etiquetas': 'Particulares - Etiquetas',
    '/calendario-eventos': 'Calendario de Eventos',
    '/reports-and-analytics': 'Reportes y Análisis',
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Inicio', path: '/' }];

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = routeLabels?.[currentPath] || segment?.replace(/-/g, ' ');
      breadcrumbs?.push({ label, path: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const handleNavigation = (path) => {
    if (path === '/') {
      navigate('/executive-dashboard');
    } else {
      navigate(path);
    }
  };

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav
      className={`flex items-center gap-2 mb-5 flex-wrap erp-breadcrumb ${className}`}
      aria-label="Breadcrumb"
    >
      {breadcrumbs?.map((crumb, index) => {
        const isLast = index === breadcrumbs?.length - 1;
        const isFirst = index === 0;

        return (
          <React.Fragment key={crumb?.path}>
            {!isFirst &&
            <Icon
              name="ChevronRight"
              size={15}
              className="text-muted-foreground flex-shrink-0" />
            }
            {isLast ?
            <span className="text-foreground font-semibold capitalize erp-breadcrumb">
                {crumb?.label}
              </span> :
            <button
              onClick={() => handleNavigation(crumb?.path)}
              className="hover:text-foreground transition-smooth capitalize font-medium text-muted-foreground hover:underline erp-breadcrumb">
                {crumb?.label}
              </button>
            }
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default BreadcrumbNavigation;